import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgJongere = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#00C5F2"
      fillRule="evenodd"
      d="M20 18a6 6 0 0 1 6 6v10H14V24a6 6 0 0 1 6-6"
      clipRule="evenodd"
    />
    <path
      fill="#00C5F2"
      d="M20 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
    />
    <path
      fill="#85E3F9"
      fillRule="evenodd"
      d="M26 12a6 6 0 1 0-12 0"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M19.497 12.947a3.02 3.02 0 0 0 6.006 0l.994.106a4.02 4.02 0 0 1-7.994 0zM15.404 7.404A6.5 6.5 0 0 1 20 5.5v1a5.5 5.5 0 0 0-5.5 5.5v.5H8v-1h5.52a6.5 6.5 0 0 1 1.884-4.096"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgJongere);

export default ForwardRef;
